<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
    <div class="spinner-border loading" role="status">
      <!-- <span class="sr-only">Loading...</span> -->
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
